module.exports = __webpack_public_path__ + "img/prize-02.f6356a5d.png";